import React from "react";
import Home from "../../pages/Home/Home";
import OurServices from "../../pages/OurServices/OurServices";
import About from "../../pages/About/About";
import Team from "../../pages/Team/Team";

import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import { AnimatePresence } from 'framer-motion'
const Routers = () => {
  const location = useLocation();

  return (
    <AnimatePresence>
      <Routes location={location} key={location.pathname}>
        <Route path="/" exact element={<Home />} />
        <Route path="/ourServices" exact element={<OurServices />} />
        <Route path="/about" exact element={<About />} />
        <Route path="/team" exact element={<Team />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AnimatePresence>
  );
};

export default Routers;
